// extracted by mini-css-extract-plugin
export default {"heading":"AgencyTodaysActivitySection_heading__3DXze"};